import { render } from "./wishlistedProduct.vue?vue&type=template&id=776d6d58&scoped=true"
import script from "./wishlistedProduct.vue?vue&type=script&lang=js"
export * from "./wishlistedProduct.vue?vue&type=script&lang=js"

import "./wishlistedProduct.vue?vue&type=style&index=0&id=776d6d58&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-776d6d58"]])

export default __exports__